<template>
  <div id="reset" class="login-type-page">
    <img class="main-logo-mobile" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
    <main>
      <div class="reset-password-box">
        <h2>{{ $t("reset-password.reset-title") }}</h2>
        <form @submit.prevent="createNewPassword">
          <p class="reset-msg">{{ $t("reset-password.reset-msg") }}</p>
          <custom-input
            v-model="model.newPassword"
            :inputType="'password'"
            :name="'newPassword'"
            :label="$t('password.new-pw-label')"
            :placeholder="$t('password.new-pw-placeholder')"
            :invalidInput="passwordIsOk == false"
            :autocomplete="'off'"
            boxed
          />
          <p class="small" style="margin-bottom:0;">
            {{ $t("password-validation.requirements-title") }}
            <span :class="!passwordMinLength ? 'text-danger' : 'text-success'">{{
              $t("password-validation.chars")
            }}</span>
            <span :class="!passwordHasCapitalLetter ? 'text-danger' : 'text-success'">{{
              $t("password-validation.uppercase")
            }}</span>
            <span :class="!passwordHasNumber ? 'text-danger' : 'text-success'">{{
              $t("password-validation.number")
            }}</span>
          </p>

          <custom-input
            v-model="model.newPasswordRepeat"
            :inputType="'password'"
            :name="'newPasswordRepeat'"
            :label="$t('password.repeat-pw-label')"
            :placeholder="$t('password.repeat-pw-label')"
            :invalidInput="passwordsMatch == false"
            :autocomplete="'off'"
            boxed
          />
          <div class="small text-danger" v-if="passwordsMatch == false">{{ $t("password-validation.no-match") }}</div>
          <button style="margin-top: 40px;" class="btn-login" type="submit" :disabled="!valid">
            {{ $t("reset-password.reset-btn") }}
          </button>
        </form>
      </div>
    </main>

    <aside>
      <div class="content">
        <img class="main-logo" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
        <h1>{{$t('login.reset-password.sideview.title')}}</h1>
        <div class="visual">
          <span>
            <i class="fa-light fa-rocket-launch"></i>
          </span>
        </div>
        <h4>{{$t('login.reset-password.sideview.sub-title')}}</h4>
        <p>{{$t('login.reset-password.sideview.description')}}</p>
      </div>
    </aside>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import debounce from "lodash/debounce";
export default {
  name: "resetPassword",
  data() {
    return {
      model: {
        newPassword: "",
        newPasswordRepeat: ""
      },
      error: false,
      invalidMsg: [],
      checkPasswordDebounce: debounce((password) => {
        this.checkPassword(password);
      }, 500),
      checkRepeatPasswordDebounce: debounce((newPassword, newPasswordRepeat) => {
        this.checkRepeatPassword(newPassword, newPasswordRepeat);
      }, 500),
      passwordLength: 0,
      passwordMinLength: false,
      passwordHasCapitalLetter: false,
      passwordHasNumber: false,
      passwordIsOk: null,
      passwordsMatch: null,
      resetToken: null
    };
  },
  computed: {
    valid() {
      return this.passwordsMatch && this.passwordIsOk;
    }
  },
  methods: {
    createNewPassword(evt) {
      evt.preventDefault();
      this.$store
        .dispatch("createNewPassword", { newPassword: this.model.newPassword, token: this.resetToken })
        .then(() => {
          this.$router.push("/login?passwordreset=true");
        })
        .catch((error) => {
          this.$router.push("/login?error=true");
        });
    },
    checkPassword(password) {
      // Min requirements - 6 letters, 1 capital, 1 number
      this.passwordLength = password.length;
      if (this.passwordLength >= 6) {
        this.passwordMinLength = true;
      } else this.passwordMinLength = false;
      this.passwordHasCapitalLetter = /[A-Z]/.test(password);
      this.passwordHasNumber = /\d/.test(password);
      if (this.passwordMinLength && this.passwordHasCapitalLetter && this.passwordHasNumber) {
        this.passwordIsOk = true;
      } else {
        this.model.newPassword == "" ? (this.passwordIsOk = null) : (this.passwordIsOk = false);
      }
    },
    checkRepeatPassword(newPassword, repeatPassword) {
      if (repeatPassword == "") this.passwordsMatch = null;
      else {
        if (newPassword === repeatPassword) this.passwordsMatch = true;
        else this.passwordsMatch = false;
      }
    }
  },
  mounted() {
    if (this.$store.token) this.$router.push("/");
  },
  beforeCreate() {
    if (!this.$route.query.token) this.$router.push("/login");
    else {
      this.$store
        .dispatch("validateResetToken", { token: this.$route.query.token })
        .then((res) => {
          this.resetToken = this.$route.query.token;
        })
        .catch((error) => {
          this.$router.push("/login?invalidtoken=true");
        });
    }
  },
  watch: {
    "model.newPassword": function(value) {
      this.checkPasswordDebounce(this.model.newPassword);
      this.checkRepeatPasswordDebounce(this.model.newPassword, this.model.newPasswordRepeat);
    },
    "model.newPasswordRepeat": function(value) {
      this.checkRepeatPasswordDebounce(this.model.newPassword, this.model.newPasswordRepeat);
    }
  },
  components: { CustomInput }
};
</script>

<style lang="less">
#reset.login-type-page {
  h1 {
    margin-bottom: 12px;
    font-size: clamp(24px, 5vh, 46px);
    color: var(--charcoal);
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 18px;
  }

  .main-logo-mobile {
    width: 180px;
    margin-bottom: 48px;
  }
}

#reset {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    form {
      width: 300px;

      .reset-msg {
        margin-top: 12px;
      }
      .btn-login {
        margin-top: 26px;
      }
    }
  }
  .to-login {
    font-size: 12px;
    text-align: center;
    margin: 36px 0 0 0;
    a {
      color: var(--charcoal-50);
      text-decoration: underline;
    }
  }
  aside {
    display: none;
  }
}

@media only screen and (min-width: 900px) {
  #reset {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .to-signup-mobile {
      display: none;
    }
    .main-logo {
      display: block;
    }
    .main-logo-mobile {
      display: none;
    }

    main {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    aside {
      height: 100vh;
      width: clamp(400px, 40vw, 550px);
      background: var(--signup-aside);
      // padding: 0 20px 0 80px;
      box-shadow: inset 2px 0px 4px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .content {
        min-height: 310px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .visual {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 200px;
        font-size: 80px;
        color: var(--orange-web);
        opacity: 0.75;
      }
      p {
        width: 250px;
        text-align: center;
      }
      .main-logo {
        display: block;
        margin-left: -8px;
        width: 180px;
      }
    }
  }
}
@media only screen and (min-width: 900px) {
  #reset {
    main {
      form {
        width: 400px;
      }
    }
  }
}
// #reset {
//   background-color: #f1f1f1;

//   .reset-password-box {
//     border-radius: var(--standard-border-radius);
//     width: 315px;
//     background-color: #fff;
//     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
//     h1 {
//       margin: 55px 0 0 55px;
//       font-size: 28px;
//       font-weight: 600;
//     }
//     form {
//       padding: 0 55px 40px 55px;

//       .btn-primary {
//         position: relative;
//         padding: 8px;
//       }
//       .error-text {
//         color: #cd4b3d;
//       }
//       .succes {
//         color: #28a745;
//       }
//       .error {
//         color: #cd4b3d;
//         margin-bottom: 5px;
//       }
//     }
//   }
//   .reset-msg {
//     color: var(--charcoal-75);
//     margin-bottom: 0;
//   }
//   .password-created-msg {
//     color: var(--charcoal-75);
//     margin: 40px 55px 10px;
//   }
//   .to-login {
//     color: var(--charcoal-50);
//     text-align: center;
//   }
//   .main-logo {
//     margin-bottom: 40px;
//     width: 180px;
//   }
// }
</style>
